<template>
  <div class="farm-window employee-card-small">
    <img class="employee-thumb" :src="image"/>
    <div class="info-panel">
      <h3 style="grid-area: name;">{{ title }}</h3>
      <ValueMeter :container="employee.mood" barColor="#194" style="grid-area: mood;">
      </ValueMeter>
      <ValueMeter :container="employee.lust" style="grid-area: lust;"
                  barColor="#c58">
      </ValueMeter>
      <ValueMeter :container="employee.milk" style="grid-area: milk;"
                  barColor="#abc"
                  :title="`Max storage: ${employee.milk.max.toFixed(1)} L`">
      </ValueMeter>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import Employee from '@/employee/Employee'
import ValueMeter from '@/components/ui/ValueMeter.vue'

@Options({
  components: {
    ValueMeter
  },
  props: {
    image: String, title: String, employee: Employee
  },
  methods: {
    log(msg: any) {
      console.log(msg)
    }
  }
})
export default class EmployeeCardSmall extends Vue {
  image!: string
  title!: string
  employee!: string
}
</script>

<style scoped lang="scss">
  .employee-card-small {
    //border: 1px solid black;
    position: relative;
    cursor: pointer;
    background-color: $component-background-color;
    padding: 0;

    transition: border $selection-time;
    &:hover {
      border-color: $highlight-color;

      div {
        border-color: $highlight-color;
      }
    }
  }

  .selected-employee {
    border-color: $highlight-color;
    div {
      border-color: $highlight-color;
    }
  }

  .employee-thumb {
    height: 100%;
    width: 100%;
    object-fit: cover;
    object-position: 50% 25%;
  }

  .info-panel {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    background-color: rgba($component-base-color, 1);
    grid-column: 2;
    padding: 0;
    text-align: left;
    border-bottom: $component-border-style;
    transition: border $selection-time;

    display: grid;
    grid-template-columns: 2fr 1fr;
    grid-template-rows: 1fr 1fr 1fr;
    grid-template-areas:
      "name mood"
      "name lust"
      "name milk";

    h3 {
      margin: 5px
    }
  }

  .value-meter {
    border-width: 0;
    border-left-width: 1px;
    height: 100%;
  }

</style>
